import React, { useContext } from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { dataContext } from "../../context/DataContextProvider";
import OilProduct from "../../OilProduct/OilProduct";
import About from "../About/About";
import AboutProduct from "../AboutProduct/AboutProduct";
import Recipes from "../Recipes/Recipes";
import Slideshow from "../Slideshow/Slideshow";
import Loading from "./../loading/Loading";
import axios from "../../services/axios";
import { useState } from "react";

const Home = ({ myRef }) => {
  const { isLoadingHome } = useContext(dataContext);

  // window.addEventListener("scroll", function () {
  //   const header = this.document.querySelector(".header");
  //   header.classList.toggle("active", this.window.scrollY > 100);
  // });
  const [siteSetting, setSiteSetting] = useState();

  const GetSiteSetting = async () => {
    const response = await axios.get("/api/V1/Ui/SiteSetting/siteSetting", {
      headers: {
        SubSystemKey: window.Configs["sub-system-key"],
      },
    });
    return response.data.data;
  };

  useEffect(() => {
    const fetchApiSS = async () => {
      const data = await GetSiteSetting();
      setSiteSetting(data);
    };
    fetchApiSS();
  }, []);


  const canonical = window.location.href;
  return (
    <div>
      <Helmet>
        <title>زراویل</title>
        <link rel="canonical" href={canonical} />
        <meta
          name="description"
          content={siteSetting && siteSetting.description}
        />
      </Helmet>
      <main>
        {isLoadingHome ? (
          <div>
            <Loading />
            <Slideshow />
          </div>
        ) : (
          <div>
            <Slideshow />
            <About myRef={myRef} />
            <OilProduct />
            <Recipes />
            <AboutProduct />
          </div>
        )}
      </main>
    </div>
  );
};

export default Home;
